import { useIsSplitEnabled } from '@buffer-mono/features'

/**
 * Gates the channel-agnostic draft feature user-facing surface: creating one
 * (the omnibox Save Draft), listing them, and reopening them.
 */
export const CHANNEL_AGNOSTIC_DRAFT_FLAG = 'geid-channel-agnostic-draft'

export function useChannelAgnosticDraftsEnabled(): boolean {
  return useIsSplitEnabled(CHANNEL_AGNOSTIC_DRAFT_FLAG)
}
